import { render } from "./SuccessOverlay.vue?vue&type=template&id=013d67da&ts=true"
import script from "./SuccessOverlay.vue?vue&type=script&lang=ts"
export * from "./SuccessOverlay.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__